import Routers from "./Route";

import CustomizerProvider from "./Shared/Utils/Customizer/CustomizerProvider";

import { ToastContainer } from "react-toastify";
import ContactProvider from "./Modules/Contacts/ContextProvider/ContactProvider";
import UserActivityProvider from "./Modules/Reports/ContextProvider/UserActivityProvider";

import AuthProvider from "./Modules/Auth/ContextProvider/AuthProvider";
import UserProvider from "./Modules/Users/ContextProvider/UserProvider";
import RoleProvider from "./Modules/Roles/ContextProvider/RoleProvider";
import EntityProvider from "./Modules/Entities/ContextProvider/EntityProvider";
import AsesorsProvider from "./Modules/Contacts/ContextProvider/AsesorsProvider";
import ContactChargeProvider from "./Modules/Listings/ContactCharges/ContextProvider/ContactChargeProvider";

import JurisdictionProvider from "./Modules/Listings/Jurisdictions/ContextProvider/JurisdictionProvider";
import PoliticSpaceProvider from "./Modules/Listings/PoliticSpace/ContextProvider/PoliticSpaceProvider";
import DistrictProvider from "./Modules/Listings/Districts/ContextProvider/DistrictProvider";
import BlockProvider from "./Modules/Listings/Blocks/ContextProvider/BlockProvider";
import AreaProvider from "./Modules/Listings/Areas/ContextProvider/AreaProvider";
import PersonalDataProvider from "./Modules/Contacts/ContextProvider/PersonalDataProvider";
import ContactDataProvider from "./Modules/Contacts/ContextProvider/ContactDataProvider";
import SocialDataProvider from "./Modules/Contacts/ContextProvider/SocialDataProvider";
import EntitySelectorProvider from "./Modules/Contacts/ContextProvider/EntitySelectorProvider";
import ComissionProvider from "./Modules/Listings/Comissions/ContextProvider/ComissionProvider";
import CityProvider from "./Modules/Cities/Context/CityProvider";
import ProvinceProvider from "./Modules/Provinces/Context/ProvinceProvider";
import AsesorSelectorProvider from "./Modules/Contacts/ContextProvider/AsesorSelectorProvider";

//import AnimationThemeProvider from "./Shared/_helper/AnimationTheme/AnimationThemeProvider";

const App = () => {
  return (
    <>
      <CustomizerProvider>
        <AuthProvider>
          <UserProvider>
            <RoleProvider>
                                        <SocialDataProvider>
              <ContactProvider>
                <EntityProvider>
                  <AsesorsProvider>
                    <ContactChargeProvider>
                      <JurisdictionProvider>
                        <PoliticSpaceProvider>
                          <DistrictProvider>
                            <BlockProvider>
                              <AreaProvider>
                                <ComissionProvider>
                                  <PersonalDataProvider>
                                    <ContactDataProvider>
                                      <SocialDataProvider>
                                        <EntitySelectorProvider>
                                          <AsesorSelectorProvider>
                                            <CityProvider>
                                              <ProvinceProvider>
                                                <Routers />
                                              </ProvinceProvider>
                                            </CityProvider>
                                          </AsesorSelectorProvider>
                                        </EntitySelectorProvider>
                                      </SocialDataProvider>
                                    </ContactDataProvider>
                                  </PersonalDataProvider>
                                </ComissionProvider>
                              </AreaProvider>
                            </BlockProvider>
                          </DistrictProvider>
                        </PoliticSpaceProvider>
                      </JurisdictionProvider>
                    </ContactChargeProvider>
                  </AsesorsProvider>
                </EntityProvider>
              </ContactProvider>
                                        </SocialDataProvider>
            </RoleProvider>
          </UserProvider>
        </AuthProvider>
      </CustomizerProvider>
      <ToastContainer />
    </>
  );
};
export default App;
